export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (to.name === 'season-individual') {
    const { $getPathFor } = useNuxtApp()

    await callOnce(async () => await useContext().fetchContext())
    const { urlBase } = useContext()

    return await navigateTo($getPathFor(`individual/180-171`, urlBase))
  }
  if (to.name === 'season-cup-group') {
    const { group } = to.params
    const { $getPathFor } = useNuxtApp()

    await callOnce(async () => await useContext().fetchContext())
    const { urlBase } = useContext()

    return await navigateTo($getPathFor(`cup/${group}/standings`, urlBase))
  }

  if (to.name === 'season-groups-group') {
    const { group } = to.params
    const { $getPathFor } = useNuxtApp()

    await callOnce(async () => await useContext().fetchContext())
    const { urlBase } = useContext()

    return await navigateTo($getPathFor(`groups/${group}/standings`, urlBase))
  }

  if (import.meta.client) {
    return
  }

  const context = await useContext().fetchContext()

  useHead({
    title: context.org.current_season.name,
    titleTemplate: (titleChunk) => {
      return titleChunk ? `${titleChunk} | ${context.org.current_season.name}` : context.org.current_season.name
    },
  })

  updateSiteConfig({
    name: context.org.current_season.name,
    url: 'https://' + context.org.domain,
  })
})
